import { useEffect, useState } from 'react';
import {
  useApi,
  identityApiRef,
  ProfileInfo,
  BackstageUserIdentity,
} from '@backstage/core-plugin-api';
import { useAsyncFn } from 'react-use';
import { sev2ApiRef } from '../api';
import { User } from '../types';

export const useMe = () => {
  const api = useApi(sev2ApiRef);
  const identityApi = useApi(identityApiRef);
  const [me, setMe] = useState<ProfileInfo | undefined>(undefined);
  const [user, setUser] = useState<User | undefined>(undefined);
  const [identity, setIdentity] = useState<BackstageUserIdentity | undefined>(
    undefined,
  );

  // GET PROFILE INFO of current logged in Backstage
  const [profileInfo, getProfileInfo] = useAsyncFn(
    () => identityApi.getProfileInfo(),
    [],
  );

  // GET IDENTITY of current logged in Backstage
  const [identityInfo, getIdentity] = useAsyncFn(
    () => identityApi.getBackstageIdentity(),
    [],
  );

  useEffect(() => {
    getProfileInfo();
  }, [getProfileInfo]);

  useEffect(() => {
    getIdentity();
  }, [getIdentity]);

  useEffect(() => {
    if (identityInfo.value) {
      setIdentity(identityInfo.value);
    }
  }, [identityInfo.value]);

  useEffect(() => {
    if (profileInfo.value) {
      setMe(profileInfo.value);
    }
  }, [profileInfo.value]);

  // GET USER of sev2 by username
  const [users, getUser] = useAsyncFn(() => {
    return api.getUserByEmail(me?.email ?? '');
  }, [me?.email]);

  useEffect(() => {
    if (me?.email) {
      getUser();
    }
  }, [getUser, me?.email]);

  useEffect(() => {
    if (users.value) {
      const user = users.value.result[0];
      setUser(user);
    }
  }, [me?.email, users.value]);

  return { me, user, identity };
};
